'use client'

import { SessionProvider } from 'next-auth/react'
import { ThemeProvider } from 'next-themes'
import { I18nProvider } from '@/components/I18nProvider'

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider>
      {/* defaultTheme="system" + enableSystem: a user with no saved choice
          follows their OS (prefers-color-scheme); once they pick System/Light/
          Dark in the toggle, next-themes persists it to localStorage and an
          inline no-flash script applies it before first paint. */}
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
        <I18nProvider>{children}</I18nProvider>
      </ThemeProvider>
    </SessionProvider>
  )
}
